import { render, staticRenderFns } from "./EnderecoEstrangeiro.vue?vue&type=template&id=23388ece&scoped=true&"
import script from "./EnderecoEstrangeiro.vue?vue&type=script&lang=js&"
export * from "./EnderecoEstrangeiro.vue?vue&type=script&lang=js&"
import style0 from "./EnderecoEstrangeiro.vue?vue&type=style&index=0&id=23388ece&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23388ece",
  null
  
)

export default component.exports